import {
  BinaryBitmap, DecodeHintType, HTMLCanvasElementLuminanceSource, HybridBinarizer, QRCodeReader,
} from '@zxing/library';

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not read the image')); };
  img.src = url;
});

const tryDecode = (img, maxSide, grayscaleBoost) => {
  const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(img.width * scale);
  canvas.height = Math.round(img.height * scale);
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (grayscaleBoost) ctx.filter = 'grayscale(1) contrast(1.6)';
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  const hints = new Map([[DecodeHintType.TRY_HARDER, true]]);
  const bitmap = new BinaryBitmap(new HybridBinarizer(new HTMLCanvasElementLuminanceSource(canvas)));
  return new QRCodeReader().decode(bitmap, hints).getText();
};

// Decodes the Aadhaar QR from a photo/screenshot, retrying at several sizes for dense Secure QRs
export const decodeQrFromFile = async (file) => {
  const img = await loadImage(file);
  for (const side of [2000, 1400, 1000, 3000, 700]) {
    for (const boost of [false, true]) {
      try {
        return tryDecode(img, side, boost);
      } catch {
        // try next size
      }
    }
  }
  throw new Error('No QR code found. Upload a clear, close-up photo of the Aadhaar QR code.');
};
